import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

import { Session } from '../../models/session';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AppSessionService {

  private readonly _secret: string = environment.session.secret;

  private _authorized: boolean = false;

  /**
   * Get authorized flag to know that logged in user is active in the app.
   */
  public get authorized(): boolean {
    return this._authorized;
  }
  
  /**
   * Get user session in session storage.
   */
  public get session(): Session | undefined {
    const encryptedSession = sessionStorage.getItem('session');

    if(!encryptedSession) 
      return undefined;

    const bytes = CryptoJS.AES.decrypt(encryptedSession, this._secret);
    const sessionString = bytes.toString(CryptoJS.enc.Utf8);
    
    return JSON.parse(sessionString);
  }

  /**
   * Save user session in session storage.
   * @param session Session.
   */
  public setSession(session: Session, authorized: boolean = true): void {
    const sessionString = JSON.stringify(session);
    const encryptSession = CryptoJS.AES.encrypt(sessionString, this._secret).toString();
    sessionStorage.setItem('session', encryptSession);
    this._authorized = authorized;
  }

  /**
   * Remove user session in session storage.
   */
  public removeSession(): void {
    sessionStorage.removeItem('session');
    this._authorized = false;
  }
}